/**
 * Bulles : popup galerie, popup newsletter et message de confirmation.
 * S'appuie sur <ModalDialog> de Release (focus piégé, blocage du scroll,
 * fermeture avec Échap et au clic sur le fond).
 */
(function () {
  'use strict';

  /* Supprime les éléments déjà déplacés dans <body> pour la même section
     (rechargement de la section dans l'éditeur de thème). */
  function removeStale(element) {
    var sectionId = element.dataset.sectionId;
    if (!sectionId) return;
    document
      .querySelectorAll(element.localName + '[data-section-id="' + sectionId + '"]')
      .forEach(function (other) {
        if (other !== element) other.remove();
      });
  }

  /* ---------- Téléphone : liste des pays (un pays principal par indicatif) ---------- */
  var PRIO = ['US', 'CA', 'RU', 'GB', 'AU', 'NO', 'RE'];
  var BUILTIN = ('FR|France|33|6 12 34 56 78;BE|Belgium|32|470 12 34 56;CH|Switzerland|41|78 123 45 67;LU|Luxembourg|352|628 123 456;' +
    'DE|Germany|49|1512 3456789;ES|Spain|34|612 34 56 78;IT|Italy|39|312 345 6789;PT|Portugal|351|912 345 678;' +
    'GB|United Kingdom|44|7400 123456;IE|Ireland|353|85 012 3456;NL|Netherlands|31|6 12345678;AT|Austria|43|664 123456;' +
    'US|United States|1|201 555 0123;CA|Canada|1|506 234 5678;AU|Australia|61|412 345 678;NZ|New Zealand|64|21 123 4567;' +
    'SE|Sweden|46|70 123 45 67;NO|Norway|47|406 12 345;DK|Denmark|45|32 12 34 56;FI|Finland|358|41 2345678;' +
    'PL|Poland|48|512 345 678;CZ|Czechia|420|601 123 456;GR|Greece|30|691 234 5678;RO|Romania|40|712 345 678;' +
    'HU|Hungary|36|20 123 4567;BG|Bulgaria|359|48 123 456;HR|Croatia|385|91 234 5678;TR|Turkey|90|501 234 56 78;' +
    'MA|Morocco|212|650-123456;DZ|Algeria|213|551 23 45 67;TN|Tunisia|216|20 123 456;EG|Egypt|20|100 123 4567;' +
    'SN|Senegal|221|70 123 45 67;CI|Côte d\'Ivoire|225|01 23 45 67 89;CM|Cameroon|237|6 71 23 45 67;ZA|South Africa|27|71 123 4567;' +
    'AE|United Arab Emirates|971|50 123 4567;SA|Saudi Arabia|966|51 234 5678;IL|Israel|972|50-234-5678;QA|Qatar|974|3312 3456;' +
    'IN|India|91|81234 56789;CN|China|86|131 2345 6789;JP|Japan|81|90-1234-5678;KR|South Korea|82|10-2345-6789;' +
    'SG|Singapore|65|8123 4567;HK|Hong Kong|852|5123 4567;TH|Thailand|66|81 234 5678;MY|Malaysia|60|12-345 6789;' +
    'BR|Brazil|55|11 96123-4567;MX|Mexico|52|222 123 4567;AR|Argentina|54|11 2345-6789;CO|Colombia|57|321 1234567;' +
    'CL|Chile|56|9 6123 4567;GP|Guadeloupe|590|690 30 12 34;MQ|Martinique|596|696 20 12 34;RE|Réunion|262|692 12 34 56;' +
    'RU|Russia|7|912 345-67-89')
    .split(';').map(function (s) { var a = s.split('|'); return { c: a[0], name: a[1], code: a[2], ex: a[3] }; });
  var CALLING_CODES = 'AD:376,AE:971,AF:93,AL:355,AM:374,AO:244,AR:54,AT:43,AU:61,AW:297,AZ:994,BA:387,BD:880,BE:32,BF:226,BG:359,BH:973,BI:257,BJ:229,BN:673,BO:591,BR:55,BT:975,BW:267,BY:375,BZ:501,CA:1,CD:243,CF:236,CG:242,CH:41,CI:225,CK:682,CL:56,CM:237,CN:86,CO:57,CR:506,CU:53,CV:238,CW:599,CY:357,CZ:420,DE:49,DJ:253,DK:45,DZ:213,EC:593,EE:372,EG:20,ER:291,ES:34,ET:251,FI:358,FJ:679,FK:500,FM:691,FO:298,FR:33,GA:241,GB:44,GE:995,GF:594,GH:233,GI:350,GL:299,GM:220,GN:224,GP:590,GQ:240,GR:30,GT:502,GW:245,GY:592,HK:852,HN:504,HR:385,HT:509,HU:36,ID:62,IE:353,IL:972,IN:91,IO:246,IQ:964,IR:98,IS:354,IT:39,JO:962,JP:81,KE:254,KG:996,KH:855,KI:686,KM:269,KP:850,KR:82,KW:965,LA:856,LB:961,LI:423,LK:94,LR:231,LS:266,LT:370,LU:352,LV:371,LY:218,MA:212,MC:377,MD:373,ME:382,MG:261,MH:692,MK:389,ML:223,MM:95,MN:976,MO:853,MQ:596,MR:222,MT:356,MU:230,MV:960,MW:265,MX:52,MY:60,MZ:258,NA:264,NC:687,NE:227,NF:672,NG:234,NI:505,NL:31,NO:47,NP:977,NR:674,NU:683,NZ:64,OM:968,PA:507,PE:51,PF:689,PG:675,PH:63,PK:92,PL:48,PM:508,PS:970,PT:351,PW:680,PY:595,QA:974,RE:262,RO:40,RS:381,RU:7,RW:250,SA:966,SB:677,SC:248,SD:249,SE:46,SG:65,SH:290,SI:386,SK:421,SL:232,SM:378,SN:221,SO:252,SR:597,SS:211,ST:239,SV:503,SY:963,SZ:268,TD:235,TG:228,TH:66,TJ:992,TK:690,TL:670,TM:993,TN:216,TO:676,TR:90,TV:688,TW:886,TZ:255,UA:380,UG:256,US:1,UY:598,UZ:998,VE:58,VN:84,VU:678,WF:681,WS:685,XK:383,YE:967,ZA:27,ZM:260,ZW:263'.split(',');
  /* Territoires non listés : on propose le pays principal ayant le même indicatif */
  var ALIAS = {AG:'US',AI:'US',AS:'US',AX:'FI',BB:'US',BL:'GP',BM:'US',BQ:'CW',BS:'US',CC:'AU',CX:'AU',DM:'US',DO:'US',EH:'MA',GD:'US',GG:'GB',GU:'US',IM:'GB',JE:'GB',JM:'US',KN:'US',KY:'US',KZ:'RU',LC:'US',MF:'GP',MP:'US',MS:'US',PR:'US',SJ:'NO',SX:'US',TC:'US',TT:'US',VA:'IT',VC:'US',VG:'US',VI:'US',YT:'RE'};

  function buildCountries(locale) {
    var known = {};
    BUILTIN.forEach(function (x) { known[x.c] = x; });
    var names = null;
    try { names = new Intl.DisplayNames([locale || 'en'], { type: 'region' }); } catch (e) { /* ignore */ }
    return CALLING_CODES.map(function (item) {
      var parts = item.split(':');
      var iso = parts[0];
      var fallback = known[iso] ? known[iso].name : iso;
      var name = fallback;
      if (names) { try { name = names.of(iso) || fallback; } catch (e) { name = fallback; } }
      return { c: iso, name: name, code: parts[1], ex: known[iso] ? known[iso].ex : '' };
    });
  }

  function esc(text) {
    return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function flag(c) {
    return String.fromCodePoint.apply(null, c.split('').map(function (ch) { return 127397 + ch.charCodeAt(0); }));
  }

  function sortCountries(a, b) {
    var ca = parseInt(a.code, 10), cb = parseInt(b.code, 10);
    if (ca !== cb) return ca - cb;
    var pa = PRIO.indexOf(a.c), pb = PRIO.indexOf(b.c);
    pa = pa < 0 ? 99 : pa; pb = pb < 0 ? 99 : pb;
    if (pa !== pb) return pa - pb;
    return a.name.localeCompare(b.name);
  }

  /* ---------- Popup galerie ---------- */
  if (!customElements.get('bubbles-gallery-modal')) {
    class BubblesGalleryModal extends ModalDialog {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.index = 0;

        var prev = this.querySelector('[data-gallery-prev]');
        var next = this.querySelector('[data-gallery-next]');

        if (this.slides.length < 2) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
        }

        if (prev) prev.addEventListener('click', this.move.bind(this, -1));
        if (next) next.addEventListener('click', this.move.bind(this, 1));

        this.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') this.move(-1);
          if (event.key === 'ArrowRight') this.move(1);
        }.bind(this));
      }

      connectedCallback() {
        removeStale(this);
        super.connectedCallback();
      }

      show(opener) {
        // précharge toutes les images pour des changements fluides
        this.querySelectorAll('img[loading="lazy"]').forEach(function (image) {
          image.loading = 'eager';
        });
        this.goTo(0, false);
        super.show(opener);
      }

      move(direction) {
        if (this.slides.length < 2) return;
        this.goTo((this.index + direction + this.slides.length) % this.slides.length, true);
      }

      goTo(index, animate) {
        this.index = index;
        this.slides.forEach(function (slide, position) {
          slide.classList.remove('is-entering');
          slide.hidden = position !== index;
        });
        if (animate) {
          var current = this.slides[index];
          void current.offsetWidth; // relance l'animation de fondu
          current.classList.add('is-entering');
        }
      }
    }

    customElements.define('bubbles-gallery-modal', BubblesGalleryModal);
  }

  /* ---------- Message de confirmation ---------- */
  if (!customElements.get('bubbles-success')) {
    class BubblesSuccess extends HTMLElement {
      connectedCallback() {
        removeStale(this);
        if (!this.moved) {
          this.moved = true;
          document.body.appendChild(this);
        }
        if (!this.bound) {
          this.bound = true;
          this.addEventListener('click', this.hide.bind(this));
        }
      }

      show(duration) {
        this.classList.add('is-open');
        clearTimeout(this.timer);
        this.timer = setTimeout(this.hide.bind(this), duration || 5000);
      }

      hide() {
        clearTimeout(this.timer);
        this.classList.remove('is-open');
      }
    }

    customElements.define('bubbles-success', BubblesSuccess);
  }

  /* ---------- Popup newsletter (e-mail + téléphone obligatoires) ---------- */
  if (!customElements.get('bubbles-newsletter-modal')) {
    class BubblesNewsletterModal extends ModalDialog {
      constructor() {
        super();
        this.mode = this.dataset.mode;
        this.form = this.querySelector('[data-bubbles-form]');
        this.input = this.querySelector('input[type="email"]');
        this.submit = this.querySelector('[data-submit]');
        this.message = this.querySelector('[data-message]');
        this.lib = null;
        this.examples = null;
        this.selected = this.dataset.defaultCountry || 'FR';

        var dismiss = this.querySelector('[data-bubbles-dismiss]');
        if (dismiss) dismiss.addEventListener('click', this.hide.bind(this));

        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.$('phone')) this.initPhone();
      }

      connectedCallback() {
        removeStale(this);
        super.connectedCallback();
      }

      $(name) {
        return this.querySelector('[data-phone="' + name + '"]');
      }

      show(opener) {
        this.clearMessage();
        super.show(opener);
        this.loadLib();
      }

      hide() {
        if (!this.hasAttribute('open')) return;
        ModalDialog.prototype.hide.call(this);
      }

      showMessage(text, type) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.dataset.type = type;
        this.message.hidden = false;
      }

      clearMessage() {
        if (!this.message) return;
        this.message.hidden = true;
        this.message.textContent = '';
        delete this.message.dataset.type;
        this.input.classList.remove('is-error');
        if (this.$('phone')) this.$('phone').classList.remove('is-error');
      }

      showSuccess() {
        var success = document.getElementById('BubblesSuccess-' + this.dataset.sectionId);
        this.hide();
        if (success && success.show) setTimeout(function () { success.show(); }, 120);
      }

      setBusy(isBusy, label) {
        if (!this.submit) return;
        this.submit.disabled = isBusy;
        if (label) this.submit.textContent = label;
      }

      /* ===================== Téléphone ===================== */
      initPhone() {
        this.setList(buildCountries(this.dataset.countryLocale));
        this.setCountry(this.selected);

        // Release (ModalDialog) bloque la remontée des clics depuis la boîte : on écoute directement les éléments
        this.$('cc-button').addEventListener('click', function () {
          this.dropdownOpen() ? this.closeDropdown() : this.openDropdown();
        }.bind(this));

        this.$('list').addEventListener('click', function (event) {
          var item = event.target.closest('.bubbles-phone__item');
          if (!item) return;
          this.setCountry(item.getAttribute('data-c'));
          this.closeDropdown();
          this.$('phone').focus();
        }.bind(this));

        // sur mobile, le blocage du scroll de la page empêche de faire défiler la liste des pays
        this.$('list').addEventListener('touchmove', function (event) { event.stopPropagation(); }, { passive: true });

        this.$('search').addEventListener('input', this.renderList.bind(this));

        this.$('phone').addEventListener('input', function (event) {
          this.formatField(event.target, event.inputType && event.inputType.indexOf('delete') === 0);
          event.target.classList.remove('is-error');
        }.bind(this));

        this.input.addEventListener('input', function () { this.input.classList.remove('is-error'); }.bind(this));

        // Échap : ferme d'abord la liste des pays, puis la fenêtre
        this.addEventListener('keyup', function (event) {
          if (event.key === 'Escape' && this.dropdownOpen()) {
            this.closeDropdown();
            event.stopImmediatePropagation();
          }
        }.bind(this), true);
      }

      setList(arr) {
        this.list = arr.slice().sort(sortCountries);
        this.byIso = {};
        this.list.forEach(function (x) { this.byIso[x.c] = x; }.bind(this));
      }

      dropdownOpen() {
        return !this.$('dropdown').hidden;
      }

      openDropdown() {
        this.$('search').value = '';
        this.renderList();
        this.$('dropdown').hidden = false;
        this.$('cc-button').setAttribute('aria-expanded', 'true');
        var selectedItem = this.$('list').querySelector('.is-sel');
        if (selectedItem) this.$('list').scrollTop = selectedItem.offsetTop - 60;
        if (this.$('dropdown').scrollIntoView) this.$('dropdown').scrollIntoView({ block: 'nearest' });
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) this.$('search').focus();
      }

      closeDropdown() {
        this.$('dropdown').hidden = true;
        this.$('cc-button').setAttribute('aria-expanded', 'false');
      }

      renderList() {
        var q = this.$('search').value.trim().toLowerCase().replace(/^\+/, '');
        var html = '';
        this.list.forEach(function (x) {
          if (q && x.name.toLowerCase().indexOf(q) < 0 && x.c.toLowerCase() !== q && x.code.indexOf(q) !== 0) return;
          html += '<li class="bubbles-phone__item' + (x.c === this.selected ? ' is-sel' : '') + '" role="option" data-c="' + x.c + '">' +
            '<span>' + flag(x.c) + ' ' + esc(x.name) + '</span><span class="bubbles-phone__code">+' + x.code + '</span></li>';
        }.bind(this));
        this.$('list').innerHTML = html || '<li class="bubbles-phone__empty">' + esc(this.dataset.noResult) + '</li>';
      }

      setCountry(c) {
        if (!this.byIso[c]) c = ALIAS[c] || 'FR';
        this.selected = c;
        this.$('cc-label').textContent = flag(c) + ' +' + this.byIso[c].code;
        this.$('phone').placeholder = this.exampleFor(c) || this.dataset.phonePlaceholder;
        if (this.$('phone').value) this.formatField(this.$('phone'));
      }

      /* ----- Bibliothèque libphonenumber (chargée à l'ouverture de la popup) ----- */
      loadLib() {
        var self = this;
        if (!BubblesNewsletterModal.libPromise) {
          var dataset = this.dataset;
          BubblesNewsletterModal.libPromise = new Promise(function (resolve) {
            var script = document.createElement('script');
            script.src = dataset.libUrl;
            script.crossOrigin = 'anonymous';
            script.onload = function () {
              var lib = window.libphonenumber;
              if (!lib || !lib.getCountries) return resolve(null);
              fetch(dataset.examplesUrl)
                .then(function (r) { return r.json(); })
                .catch(function () { return null; })
                .then(function (examples) { resolve({ lib: lib, examples: examples }); });
            };
            script.onerror = function () { resolve(null); };
            document.head.appendChild(script);
          });
        }
        return BubblesNewsletterModal.libPromise.then(function (loaded) {
          if (!loaded || self.lib) return;
          self.lib = loaded.lib;
          self.examples = loaded.examples;
          self.setCountry(self.selected);
        });
      }

      exampleFor(c) {
        if (this.lib && this.examples) {
          try {
            var example = this.lib.getExampleNumber(c, this.examples);
            if (example) {
              var code = this.lib.getCountryCallingCode(c);
              return example.formatInternational().replace(new RegExp('^\\+' + code + '\\s*'), '');
            }
          } catch (e) { /* ignore */ }
        }
        return this.byIso[c] && this.byIso[c].ex ? this.byIso[c].ex : '';
      }

      groupByExample(digits, c) {
        var example = this.exampleFor(c);
        if (!example) return digits;
        var groups = example.split(/[^\d]+/).filter(Boolean).map(function (g) { return g.length; });
        var out = [], i = 0;
        for (var g = 0; g < groups.length && i < digits.length; g++) {
          var size = (g === groups.length - 1) ? digits.length - i : groups[g];
          out.push(digits.substr(i, size));
          i += size;
        }
        return out.join(' ');
      }

      formatField(el, isDelete) {
        var val = el.value;
        var pos = el.selectionStart == null ? val.length : el.selectionStart;
        var digitsBefore = val.slice(0, pos).replace(/\D/g, '').length;
        var plus = val.trim().charAt(0) === '+';
        var digits = val.replace(/\D/g, '');
        var prev = el.getAttribute('data-d') || '';

        if (isDelete && digits === prev && digitsBefore > 0) {
          digits = digits.slice(0, digitsBefore - 1) + digits.slice(digitsBefore);
          digitsBefore--;
        }

        var code = this.byIso[this.selected] ? this.byIso[this.selected].code : '';
        var national = digits;
        if (!plus && national.charAt(0) === '0') {
          national = national.slice(1);
          digitsBefore = Math.max(0, digitsBefore - 1);
        }

        var formatted = null;
        if (this.lib && this.lib.AsYouType && digits) {
          try {
            formatted = plus
              ? new this.lib.AsYouType().input('+' + digits)
              : new this.lib.AsYouType().input('+' + code + national).replace('+' + code, '').trim();
          } catch (e) { formatted = null; }
        }
        if (formatted === null) formatted = plus ? '+' + digits : this.groupByExample(national, this.selected);
        if (!digits) formatted = plus ? '+' : '';

        el.value = formatted;
        el.setAttribute('data-d', plus ? digits : national);

        var count = 0, caret = 0;
        if (digitsBefore > 0) {
          for (var i = 0; i < formatted.length; i++) {
            if (/\d/.test(formatted.charAt(i))) count++;
            if (count === digitsBefore) { caret = i + 1; break; }
          }
          if (!caret) caret = formatted.length;
        } else {
          caret = plus ? 1 : 0;
        }
        try { el.setSelectionRange(caret, caret); } catch (e) { /* ignore */ }
      }

      /* Numéro valide → { number: '+33612345678' } ; sinon { error: true } */
      validatePhone() {
        var raw = this.$('phone').value.trim();
        var x = this.byIso[this.selected] || { code: '' };

        if (this.lib) {
          var parsed = null;
          try { parsed = this.lib.parsePhoneNumberFromString(raw, this.selected); } catch (e) { /* ignore */ }
          if (parsed && parsed.isValid()) {
            var type = parsed.getType();
            if (type && type !== 'MOBILE' && type !== 'FIXED_LINE_OR_MOBILE') return { error: true };
            return { number: parsed.number };
          }
          return { error: true };
        }

        // Validation de secours (bibliothèque non chargée)
        var digits = raw.replace(/\D/g, '');
        if (raw.charAt(0) === '+') {
          if (digits.indexOf(x.code) !== 0) return { error: true };
          digits = digits.slice(x.code.length);
        }
        if (digits.charAt(0) === '0') digits = digits.slice(1);
        var example = this.exampleFor(this.selected);
        var expected = example ? example.replace(/\D/g, '').replace(/^0/, '').length : 0;
        if (expected && (digits.length < expected - 1 || digits.length > expected + 1)) return { error: true };
        if (digits.length < 6 || digits.length > 13) return { error: true };
        return { number: '+' + x.code + digits };
      }

      /* ===================== Envoi ===================== */
      onSubmit(event) {
        event.preventDefault();
        var data = this.dataset;
        this.clearMessage();

        var email = this.input.value.trim();
        var phoneRaw = this.$('phone').value.trim();

        if (!email || !phoneRaw) {
          if (!email) this.input.classList.add('is-error');
          if (!phoneRaw) this.$('phone').classList.add('is-error');
          this.showMessage(data.errorRequired, 'error');
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.input.classList.add('is-error');
          this.showMessage(data.errorEmail, 'error');
          return;
        }
        var phone = this.validatePhone();
        if (phone.error) {
          this.$('phone').classList.add('is-error');
          this.showMessage(data.errorPhone, 'error');
          return;
        }

        if (this.mode === 'klaviyo') this.subscribeKlaviyo(email, phone.number);
        else this.subscribeShopify(email, phone.number);
      }

      resetFields() {
        this.input.value = '';
        this.$('phone').value = '';
        this.$('phone').removeAttribute('data-d');
        this.closeDropdown();
      }

      /* Formulaire natif Shopify : e-mail dans Clients (POST /contact#newsletter), numéro en tag
         (« phone:+33… ») et, si renseignée, dans Google Sheets. */
      subscribeShopify(email, phone) {
        var form = this.form;
        var data = this.dataset;
        var originalLabel = this.submit ? this.submit.textContent : '';
        this.setBusy(true);

        var body = new FormData(form);
        body.set('contact[tags]', 'newsletter,phone:' + phone);

        fetch(form.action, {
          method: 'POST',
          body: body,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        })
          .then(function (response) {
            // Succès : Shopify redirige vers /contact?customer_posted=true
            if (response.ok && response.url.indexOf('customer_posted=true') !== -1) {
              this.sendToSheets(email, phone);
              this.resetFields();
              this.setBusy(false, originalLabel);
              this.showSuccess();
              return;
            }

            // Page de vérification (captcha) : on laisse Shopify l'afficher normalement
            if (response.url.indexOf('challenge') !== -1) {
              form.submit();
              return;
            }

            throw new Error('subscription_failed');
          }.bind(this))
          .catch(function () {
            this.setBusy(false, originalLabel);
            this.showMessage(data.errorText, 'error');
          }.bind(this));
      }

      /* Google Sheets (facultatif) : envoi « au mieux », sans bloquer l'inscription */
      sendToSheets(email, phone) {
        var base = this.dataset.scriptUrl;
        if (!base) return;
        try {
          var url = new URL(base);
          url.searchParams.set('email', email);
          url.searchParams.set('phone', phone);
          url.searchParams.set('type', 'registration_shopify_get');
          url.searchParams.set('timestamp', String(Date.now()));
          fetch(url.toString(), { method: 'GET', mode: 'no-cors', keepalive: true }).catch(function () { /* ignore */ });
        } catch (e) { /* ignore */ }
      }

      /* Klaviyo : e-mail + téléphone dans la même inscription, avec la clé publique */
      subscribeKlaviyo(email, phone) {
        var data = this.dataset;
        var originalLabel = this.submit.textContent;
        var withSms = data.subscribeSms === 'true';
        this.setBusy(true, data.loadingText);

        var build = function (includeSms) {
          var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
          if (includeSms) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
          return JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Newsletter Popup Custom',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email, phone_number: phone, subscriptions: subscriptions }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: data.klaviyoList } } }
            }
          });
        };

        var post = function (body) {
          return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(data.klaviyoKey), {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              revision: data.klaviyoRevision,
              'content-type': 'application/vnd.api+json'
            },
            body: body
          });
        };

        var failure = function (response) {
          return response.json().catch(function () { return null; }).then(function (body) {
            var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
            throw new Error(detail || data.errorText);
          });
        };

        post(build(withSms))
          .then(function (response) {
            if (response.ok) return null;
            // Si le consentement SMS est refusé (liste non configurée pour le SMS), on réessaie avec l'e-mail
            // seul : le numéro reste enregistré sur le profil.
            if (withSms) {
              return post(build(false)).then(function (retry) {
                if (retry.ok) return null;
                return failure(retry);
              });
            }
            return failure(response);
          })
          .then(function () {
            this.resetFields();
            this.setBusy(true, data.subscribedText);
            setTimeout(function () {
              this.showSuccess();
              setTimeout(function () { this.setBusy(false, originalLabel); }.bind(this), 250);
            }.bind(this), 250);
          }.bind(this))
          .catch(function (error) {
            this.showMessage(error.message || data.errorText, 'error');
            this.setBusy(false, data.retryText);
          }.bind(this));
      }
    }

    customElements.define('bubbles-newsletter-modal', BubblesNewsletterModal);
  }

  /* ---------- Ouverture depuis les bulles ---------- */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bubbles-open]');
    if (!trigger) return;
    var modal = document.getElementById(trigger.getAttribute('data-bubbles-open'));
    if (modal && typeof modal.show === 'function') {
      event.preventDefault();
      modal.show(trigger);
    }
  });

  /* ---------- Éditeur de thème : nettoyage à la suppression de la section ---------- */
  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (!id) return;
    document
      .querySelectorAll('[data-section-id="' + id + '"]')
      .forEach(function (element) {
        if (/^bubbles-/.test(element.localName)) element.remove();
      });
  });

  /* ---------- Retour d'un envoi natif (sans JavaScript) : /contact?customer_posted=true#newsletter ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return;
    var success = document.querySelector('bubbles-success');
    if (!success) return;
    success.show();
    window.history.replaceState({}, document.title, window.location.pathname);
  });
})();